import React from 'react';
import HCaptchaComponent from '@hcaptcha/react-hcaptcha';

interface HCaptchaProps {
  onVerify: (token: string) => void;
  onError?: (error: Error) => void;
  onExpire?: () => void;
}

export default function HCaptcha({ onVerify, onError, onExpire }: HCaptchaProps) {
  const sitekey = import.meta.env.VITE_HCAPTCHA_SITE_KEY;

  if (!sitekey) {
    console.error('HCaptcha site key is not configured');
    return null;
  }

  return (
    <div className="h-[76px] flex justify-center items-center">
      <HCaptchaComponent
        sitekey={sitekey}
        onVerify={onVerify}
        onError={onError}
        onExpire={onExpire}
        theme="light"
        size="normal"
      />
    </div>
  );
}